import React from 'react';
import { Box, Dialog, DialogContent, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function HelpDialog({ open, onClose }) {
  return (
      <Dialog
        open={open}
        onClose={() => onClose()}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%)',
            px: 3,
            py: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ color: '#fff', fontWeight: 700 }}
            >
              คู่มือการใช้งาน
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: 'rgba(255,255,255,0.65)' }}
            >
              คลิกซ้าย / ดับเบิลคลิก / คลิกขวา ในแต่ละ Column
            </Typography>
          </Box>
          <IconButton
            onClick={() => onClose()}
            sx={{
              color: 'rgba(255,255,255,0.7)',
              '&:hover': { color: '#fff' },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ p: 0 }}>
          {(() => {
            const rows = [
              {
                col: 'Header ทุกคอลัมน์',
                left: 'เรียงลำดับ ↑↓ (กดวนซ้ำ)',
                dbl: '—',
                right: '—',
                admin: false,
              },
              {
                col: '2 · Status',
                left: 'แก้ไขสถานะโครงการ',
                dbl: '—',
                right: '—',
                admin: true,
              },
              {
                col: '3 · Progress %',
                left: 'แก้ไขตัวเลข % ความก้าวหน้า',
                dbl: '—',
                right: '—',
                admin: true,
              },
              {
                col: '4 · ชื่อโครงการ',
                left: 'กรองตามโครงการ (กดซ้ำเพื่อยกเลิก)',
                dbl: 'เปิดรายละเอียดโครงการ',
                right: 'แสดงชื่อเต็ม',
                admin: false,
              },
              {
                col: '5 · ลูกค้า',
                left: 'กรองตามลูกค้า (กดซ้ำเพื่อยกเลิก)',
                dbl: 'เปิดรายละเอียดโครงการ',
                right: 'เปิด Contact card',
                admin: false,
              },
              {
                col: '7 · Billed  /  8 · Received  /  12 · AP Pending',
                left: 'กำหนดค่าตั้งต้น (ข้อมูลก่อนเข้าระบบ)',
                dbl: '—',
                right: '—',
                admin: true,
              },
              {
                col: '16 · To Spend',
                left: 'แก้ไขยอดที่คาดว่าจะต้องใช้',
                dbl: '—',
                right: '—',
                admin: true,
              },
              {
                col: '26 · หมายเหตุ',
                left: 'แก้ไขหมายเหตุโครงการ',
                dbl: '—',
                right: '—',
                admin: true,
              },
              {
                col: '27 · วันที่ส่งงาน',
                left: 'กำหนด / แก้ไขวันที่ส่งงาน',
                dbl: '—',
                right: '—',
                admin: true,
              },
            ];
            const CELL = {
              padding: '8px 16px',
              fontSize: '0.88rem',
              borderBottom: '1px solid rgba(0,0,0,0.06)',
              verticalAlign: 'top',
            };
            const HEAD = {
              ...CELL,
              fontWeight: 700,
              backgroundColor: '#f1f5f9',
              fontSize: '0.8rem',
              color: '#475569',
              letterSpacing: '0.04em',
            };
            return (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {[
                      'Column',
                      'คลิกซ้าย 🖱',
                      'ดับเบิลคลิก 🖱🖱',
                      'คลิกขวา 🖱',
                    ].map((h) => (
                      <th key={h} style={{ ...HEAD, textAlign: 'left' }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr
                      key={i}
                      style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                    >
                      <td
                        style={{
                          ...CELL,
                          fontWeight: 600,
                          color: '#1e3a5f',
                          whiteSpace: 'pre-wrap',
                        }}
                      >
                        {r.col}
                        {r.admin && (
                          <Box
                            component="span"
                            sx={{
                              ml: 1,
                              fontSize: '0.72rem',
                              bgcolor: '#fef3c7',
                              color: '#92400e',
                              px: 0.7,
                              py: 0.2,
                              borderRadius: 1,
                              fontWeight: 600,
                            }}
                          >
                            Admin
                          </Box>
                        )}
                      </td>
                      <td
                        style={{
                          ...CELL,
                          color: r.left === '—' ? '#cbd5e1' : '#0f172a',
                        }}
                      >
                        {r.left}
                      </td>
                      <td
                        style={{
                          ...CELL,
                          color: r.dbl === '—' ? '#cbd5e1' : '#0f172a',
                        }}
                      >
                        {r.dbl}
                      </td>
                      <td
                        style={{
                          ...CELL,
                          color: r.right === '—' ? '#cbd5e1' : '#0f172a',
                        }}
                      >
                        {r.right}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}
          <Box
            sx={{
              px: 3,
              py: 1.5,
              bgcolor: '#f8fafc',
              borderTop: '1px solid rgba(0,0,0,0.06)',
            }}
          >
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              💡 ลาก header ขอบขวาเพื่อปรับความกว้าง column ·
              ลากพื้นที่ว่างในตารางเพื่อ scroll
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
  );
}
